module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUpJREFUOE/NlDEvRUEQhb9JXqFQKBWvkdDRKRQSRCXRqESFkCAkT09B/AESCYVGRKWg02qEUqKg5wcoFIqXHJlkydrsde97XmGbW+zMN3Pmzh6jw8c6zMMkHQHLQC0D/wBugI1wdwiMA10FjRw7UMBVSEzjeoCFCOAFToD3DNALTX8BN83sIFdVUi/wFO6GzOy1IK4B7JcCPVnStX/NbErSJDAYQd+Ac2C9FeBlAM5IugNGIqDLHwBm2wIWbYWkliTHHS4lkr3D3b9IPgNGkxlOAPP/RvJeRvIa4KOovDbxDLeA4UiyL/sisNIWsOpf3gFOM8FNfxmS4g7rBe/eJW/7S3lMZpJynxNA/y8O9eDAbmCsoKq7ympwGOfc+5wAn1t6msBtqR9KcugL4Al9ZpaDfcNLgcEcLhxoZnNlhlwV6F3WzCzngz9qfAKiuctOqF/p+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/search_course@2x.png
// module id = DDoR
// module chunks = 1